export const CHANGE_PASSWORD_REQUEST="CHANGE_PASSWORD_REQUEST"
export const CHANGE_PASSWORD_SUCCESS="CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAILURE="CHANGE_PASSWORD_FAILURE"
export const RESET_CHANGE_PASSWORD="RESET_CHANGE_PASSWORD"